
import filter_array from './class_filter_arrays';
import checkLanguage from "./class_check_language";
export default class filter_sorgenti {

    filter_sorgenti_modello( modello, prodotti_vendibili ) {
        let f = new filter_array( );
        let sorgenti = f.key_value( prodotti_vendibili , 'modello_var', modello );
        return sorgenti;
    }

    filter_sorgenti_vetro( modello, prodotti_vendibili ) {
        let f = new filter_array( );
        let sorgenti = f.key_value( prodotti_vendibili , 'testo_finitura', modello );
        return sorgenti;
    }
    filter_sorgenti_paese( paese, prodotti_vendibili ) {
        let f = new filter_array( );
        let sorgenti = f.key_value( prodotti_vendibili , 'PAESE', paese );
        return sorgenti;
    }

    filter_sorgenti_finitura( modello, prodotti_vendibili ) {
        let f = new filter_array( );
        let sorgenti = f.key_value( prodotti_vendibili , 'testo_finiturastruttura', modello );
        return sorgenti;
    }

    ottieni_sorgenti(mv, m, fs, prodotti_vendibili) {
        let a =  this.filter_sorgenti_modello(mv, prodotti_vendibili);
        let b =  this.filter_sorgenti_vetro(m, a);
        let c =  this.filter_sorgenti_finitura(fs, b);
        console.info('d ottieni sorgenti ....', c);
        c = this.cicla_elementi_modifica_test_led(c);
        // qui devo ciclare tutti gli elementi ottenuti e se è presente un elemento che contiene alt allora devo aggiungere alternativa


        return c;
    }


    cicla_elementi_modifica_test_led(c){
        try {
            let alt = 'Alternative light source: ';
            let i = new checkLanguage();
            if (i.is_italian()) {
                alt = 'Sorgente alternativa: ';
            }
            let d = [];
            c.forEach(element => {
                if (element.el_alt.length >0){
                    element.test_led = this.crea_html_select(element.el_main, element.el_alt, alt); 
                }
                console.info('PPPPPPPPPPPPPPPPPPPPPPPPPP');
                console.info('elemento select...', element);
                console.info(element);
                console.info('PPPPPPPPPPPPPPPPPPPPPPPPPP');
                d.push(element);
            });

            return d;

        } catch (error) {
            console.log(error);
            return c;
        }
       
    }

    crea_html_select(main, alt, c){
//        return '<div class="inner_vix"> <p class="el_main_vix">' + element.el_main+ '</p><p class="el_alternative_vix">' + alt + element.el_alt +'</p> </div>';
        return '<div class="inner_vix"> <p class="el_main_vix">' + main+ '</p><p class="el_alternative_vix">' + c + alt +'</p> </div>';
    }

    ottieni_sorgenti_paese(mv, m, fs, ps, prodotti_vendibili) {
         let a =  this.filter_sorgenti_modello(mv, prodotti_vendibili);
         let b =  this.filter_sorgenti_vetro(m, a);
         let c =  this.filter_sorgenti_finitura(fs, b);
         let d =  this.filter_sorgenti_paese(ps, c);
         d = this.cicla_elementi_modifica_test_led(c);
         console.info('d ottieni sorgenti paese....', d);

         return d;
     }
    ottieni_sorgente_value(LED, prodotti){
        let f = new filter_array( );
        let sorgenti = f.key_value( prodotti , 'SORGENTE', LED );
        return sorgenti;
    }
    ottieni_sorgente_value_cod(cod, prodotti){
        let f = new filter_array( );
        let sorgenti = f.key_value( prodotti , 'id_prodotto', cod );
        return sorgenti[0];
    }

    ottieni_sorgenti_list(prodotti_vendibili){
        let f = new filter_array( );
        let sorgenti = f.group_by_value( prodotti_vendibili , 'SORGENTE' );
        return sorgenti;
    }

}